import { ApiProperty } from '@nestjs/swagger';

export class ImageAssetItemResizedImage {
  @ApiProperty()
  path: string;

  @ApiProperty()
  width: number;

  @ApiProperty()
  height: number;
}

export class ImageAssetItem {
  @ApiProperty()
  src: string;

  @ApiProperty()
  width: number;

  @ApiProperty()
  height: number;

  @ApiProperty({ required: false })
  srcSet?: string;

  @ApiProperty({ required: false })
  mimeType?: string;

  @ApiProperty({ type: ImageAssetItemResizedImage, required: false, isArray: true })
  images?: ImageAssetItemResizedImage[];
}

export class ImageAsset {
  @ApiProperty({ type: ImageAssetItem })
  base: ImageAssetItem;

  @ApiProperty({ type: ImageAssetItem, required: false })
  webp?: ImageAssetItem;
}
